import React from "react";
import ProductComingSoonLanding from "./ProductComingSoonLanding.jsx";

const HERO_TAGS = ["Chain break", "Auction", "Refurb exit"];

const FEATURE_CARDS = [
  {
    title: "Bridge cost & net loan estimates",
    description:
      "Model gross loan, net advance, rolled interest, and arrangement costs for short-term finance scenarios.",
  },
  {
    title: "Exit-strategy aware matching",
    description:
      "Highlight lenders comfortable with your planned exit—sale, refinance onto term debt, or development completion.",
  },
  {
    title: "Shortlist & apply in one journey",
    description:
      "When live, move from indicative bridge numbers to application without re-keying borrower data.",
  },
];

const STEPS = [
  {
    title: "Set security, term, and exit",
    body: "Property details, required loan, and how you’ll repay steer which bridge lenders are in scope.",
  },
  {
    title: "Compare bridge pricing",
    body: "Review indicative monthly interest, fees, and net proceeds across matched bridging products.",
  },
  {
    title: "Shortlist and apply",
    body: "Choose bridge options to progress with when Dynesourcer launches live bridging sourcing.",
  },
];

const CRITERIA_CHIPS = [
  "Gross loan & LTV",
  "Term (months)",
  "Regulated vs unregulated",
  "First / second charge",
  "Exit route (sale, refinance, etc.)",
  "Property condition",
  "Auction deadlines",
  "Interest serviced vs rolled",
  "Valuation type & asset class",
];

export default function BridgingCalculator() {
  return (
    <ProductComingSoonLanding
      productLabel="Bridging"
      heroTitle="Bridging Finance Calculator"
      heroDescription="Short-term finance for purchases, refinances, and exits—with speed and clarity. Coming soon."
      heroSrc="/Bridingload.webp"
      primaryCtaText="Source bridging (Coming soon)"
      heroTags={HERO_TAGS}
      introTitle="Bridging calculator (Coming soon)"
      introBody="Bridging is time-sensitive. Dynesourcer will combine fast indicative numbers with lender criteria so borrowers know what’s realistic before they commit. This page previews that experience."
      featureCards={FEATURE_CARDS}
      howItWorksTitle="How bridging will work on Dynesourcer"
      howItWorksIntro="Borrowers outline urgency, security, and repayment plan; we match bridge lenders whose boxes are ticked."
      steps={STEPS}
      criteriaTitle="Typical bridging criteria (preview)"
      criteriaIntro="Bridge lenders focus on security, exit, and loan mechanics. Common preview filters are listed below."
      criteriaChips={CRITERIA_CHIPS}
      ctaTitle="Need bridging finance?"
      ctaDescription="Explore the borrower journey while we wire up live bridging data and calculator outputs."
      ctaPrimary={{ to: "/explore-borrower-journey", label: "Explore borrower journey" }}
      ctaSecondary={{ to: "/sourcing/buy-to-let-mortgage-sourcing", label: "Try BTL sourcing today" }}
    />
  );
}
